import { render } from "./UserForm.vue?vue&type=template&id=a3a829e2"
import script from "./UserForm.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./UserForm.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script